import { render, staticRenderFns } from "./ledger-error-log.vue?vue&type=template&id=6f87bb53&scoped=true&"
import script from "./ledger-error-log.vue?vue&type=script&lang=js&"
export * from "./ledger-error-log.vue?vue&type=script&lang=js&"
import style0 from "./ledger-error-log.vue?vue&type=style&index=0&id=6f87bb53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f87bb53",
  null
  
)

export default component.exports